import React, { useEffect, useState, useCallback,useRef } from "react";
import edit from "../../Assets/svg/edit.svg";
import dt from "../../Assets/svg/delete.svg";
import lar from "../../Assets/svg/lar.svg";
import rar from "../../Assets/svg/rar.svg";
import cancel from "../../Assets/svg/cancel.svg";
import Modal from "@mui/material/Modal";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import { apiCall } from "../../services/api-service.js";
import ReactPaginate from "react-paginate";
import DeleteModal from "../common/DeleteModal";
import ListFooter from "../common/ListFooter.jsx";
import ReportButton from "../common/ReportButton.jsx";
import { useExcelActions } from "../../hooks/useExcelActions";
import SearchWithAPI from "../common/searchbox/searchbox.js";
import { useNavigate } from "react-router-dom";
import { useGlobal } from "../../GlobalContext.js";

const EscalationList = ({ children }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { rolePermissionList } = useGlobal();

  const [escalationId, setEscalationId] = useState(-1);
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [componentCode, setComponentCode] = useState("");
  const [componentName, setComponentName] = useState("");
  const [estimation, setEstimation] = useState("");
  const [lastKey, setLastKey] = useState("");
  const [selectedSubComponentOption, settSubComponentOption] = useState(null);
  const [subComponents, setSubComponents] = useState([]);
  const [validations, setValidations] = useState({
    code: "",
    name: "",
    est: "",
    subcomponents: "",
  });
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }
  const handleClose = () => {
    setEscalationId(-1);
    setValidations({
      code: "",
      name: "",
      est: "",
      subcomponents: "",
    });

    setComponentCode("");
    setComponentName("");
    setEstimation("");
    setSubComponents([]);
    settSubComponentOption(null);
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleSubComponentDropdownChange = (option) => {
    console.log(option);
    settSubComponentOption(option);
  };
  const handleModalContentClick = (e) => {
    e.stopPropagation();
  };
  const [escalationList, setEscalationList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [status, setStatus] = useState("All");
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    getListData(searchTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, itemsPerPage, itemOffset]);

  const handlePageClick = useCallback(
    (event) => {
      const newOffset = event.selected * itemsPerPage;
      setItemOffset(newOffset); // Not event.selected
    },
    [itemsPerPage]
  );
  const [deleteId, setDeleteId] = useState(null);
  const deleteTeam = (id) => {
    setDeleteId(id);
    setIsOpenDelete(true);
  };
  const deleteApi = async () => {
    if (deleteId == null) return;
    const response = await apiCall("delete", `escalation/${deleteId}`);
    if (response?.status === 200) {
      if (response.data?.success === true) {
        setDeleteId(null);
        setIsOpenDelete(false);
        getListData("");
      }
      setSnackbarMessage(response.data?.message ?? "");
      setSnackbarStatus(response.data?.success ?? false);
      handleSnackbarShow();
    }
  };
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  const handleSearch = debounce((term) => {
    // A new search starts from the first page. If already on page 1, fetch
    // directly; otherwise reset the offset and let the itemOffset effect fetch.
    if (itemOffset === 0) {
      getListData(term, 0);
    } else {
      setItemOffset(0);
    }
  }, 1000);

  const getListData = async (term, skip = itemOffset) => {
    const response = await apiCall("get", "escalation", null, {
      params: {
        limit: itemsPerPage,
        skip,
        search: term,
        status,
      },
    });
    if (response?.status === 200 && response.data?.success === true) {
      const totalPages = response.data.total_pgs ?? 0;
      setTotalCount(response.data.total_rec ?? 0);
      setPageCount(totalPages);
      setEscalationList(response.data.escalations ?? []);

      // Snap back to the last page if the current page is now out of range.
      const currentPage = Math.floor(skip / itemsPerPage);
      if (currentPage > totalPages) {
        setItemOffset(totalPages * itemsPerPage);
      }
    }
  };

  const { reportLoading, downloadReport } = useExcelActions("escalation", getListData, {
    setSnackbarMessage,
    setSnackbarStatus,
    handleSnackbarShow,
  }, "escalation_master");

  const handleApiError = (errorData) => {
    const validationTemp = { code: "", name: "", est: "", subcomponents: "" };
    if (errorData?.error) {
      Object.entries(errorData.error).forEach(([key, value]) => {
        validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : "";
      });
    }
    setValidations(validationTemp);
  };

  const componentSubmit = async () => {
    setValidations({ code: "", name: "", est: "", subcomponents: "" });
    const requestBody = {
      code: componentCode,
      name: componentName,
      est: estimation,
      subcomponents: subComponents.map((item) => item.value),
    };
    const isNew = escalationId === null || escalationId === undefined || escalationId === -1;
    const response = await apiCall(
      isNew ? "post" : "put",
      isNew ? "escalation" : `escalation/${escalationId}`,
      requestBody
    );
    if (response?.status === 200 && response.data?.success === true) {
      handleClose();
      getListData("");
    } else if (response?.data?.error) {
      handleApiError(response.data);
    }
  };


  return (
    <Container fluid style={{ width: "100%", padding: "0px" }}>
      <div className="d-flex side4">
        {/* <div className="d-none d-lg-block">
          <Sidebar selectedTab={"Escalation"} />
        </div> */}
        <Row
          sm={12}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            // height: "100vh",
            // overflow: "auto",
            // scrollbarWidth: "none",
            // msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            {/* <div className="top3">
              <Topbar selectedTab={"Escalation"} />
            </div> */}
            <div className="maincontent3">
              <div
                style={{
                  borderRadius: "16px",
                  padding: "16px",
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ gap: "12px" }}>
                  <div>
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "20px",
                        lineHeight: "22px",
                        color: "#212129",
                      }}
                    >
                      Escalation
                    </span>
                    <p
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "22px",
                        color: "#8790A1",
                      }}
                    >
                      Manage your escalations list here
                    </p>
                  </div>
                </div>
                <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                 
                  {checkPermission("Escalation", "create_permission") && (
                    <button
                      onClick={() => {
                        navigate("/escalation/add");
                      }}
                      style={{
                        height: "40px",
                        borderRadius: "100px",
                        padding: "8px 16px 8px 16px",
                        gap: "8px",
                        backgroundColor: "#6929E2",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textDecoration: "none",
                      }}
                    >
                      <p
                        style={{
                          margin: "0",
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "14px",
                          lineHeight: "18.9px",
                          color: "#FFFFFF",
                        }}
                      >
                        + New escalation
                      </p>
                    </button>
                  )}
                </div>

                <Modal
                  onClose={handleClose}
                  open={open}
                  BackdropProps={{ onClick: (e) => e.stopPropagation() }}
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    top: "0px",
                    left: "0px",
                  }}
                >
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "transparent",
                      opacity: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 1000,
                    }}
                  >
                    <div
                      style={{
                        width: "520px",
                        overflowY: "auto",
                        borderRadius: "16px",
                        padding: "24px",
                        gap: "16px",
                        backgroundColor: "#FFFFFF",
                      }}
                    >
                      <div
                        style={{
                          gap: "24px",
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "16px",
                        }}
                      >
                        <div>
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "20px",
                              lineHeight: "27px",
                              color: "#212129",
                              display: "block",
                            }}
                          >
                            Add Escalation
                          </span>
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "400",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#8790A1",
                            }}
                          >
                            Enter below details to create new escalation
                          </span>
                        </div>
                        <div>
                          <img src={cancel} alt="" onClick={handleClose} />
                        </div>
                      </div>
                      <div style={{ marginBottom: "16px" }}>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            marginBottom: "8px",
                            color: "#212129",
                            display: "block",
                          }}
                        >
                          Component Code
                        </span>
                        <input
                          type="text"
                          value={componentCode}
                          onChange={(event) => {
                            setComponentCode(event.target.value);
                          }}
                          style={{
                            borderRadius: "10px",
                            border: "1.4px solid #E5E5E5",
                            padding: "16px",
                            gap: "77px",
                            backgroundColor: "#FFFFFF",
                            height: "44px",
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#21272C",
                          }}
                          className="col-12"
                        />
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                          }}
                        >
                          {validations.code}
                        </span>
                      </div>
                      <div style={{ marginBottom: "16px" }}>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            marginBottom: "8px",
                            color: "#212129",
                            display: "block",
                          }}
                        >
                          Component Name
                        </span>
                        <input
                          type="text"
                          value={componentName}
                          onChange={(event) => {
                            setComponentName(event.target.value);
                          }}
                          style={{
                            borderRadius: "10px",
                            border: "1.4px solid #E5E5E5",
                            padding: "16px",
                            gap: "77px",
                            backgroundColor: "#FFFFFF",
                            height: "44px",
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#21272C",
                          }}
                          className="col-12"
                        />
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                          }}
                        >
                          {validations.name}
                        </span>
                      </div>

                      <div style={{ marginBottom: "16px" }}>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            marginBottom: "8px",
                            color: "#212129",
                            display: "block",
                          }}
                        >
                          Estimation Duration
                        </span>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <input
                            type="text"
                            value={estimation}
                            onChange={(event) => {
                              const inputText = event.target.value;
                              if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
                                console.log(event.key);
                                if (lastKey === "Backspace") {
                                  setEstimation(inputText);
                                } else {
                                  setEstimation(
                                    inputText.length === 2
                                      ? inputText + ":"
                                      : inputText
                                  );
                                }
                              }
                            }}
                            onKeyDown={(event) => {
                              setLastKey(event.key);
                            }}
                            placeholder="00:00 Hrs"
                            style={{
                              padding: "16px 8px 16px 8px",
                              borderRadius: "10px",
                              backgroundColor: "#FFFFFF",
                              border: "0.7px solid #E5E5E5",
                              height: "44px",
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#21272C",
                            }}
                            className="col-12"
                            maxLength={5}
                          />
                          {/* <div style={{width:'40px',height:'40px',display:'flex',justifyContent:'center',alignItems:"center",border:'1px solid #E5E5E5',borderRadius:'100px'}}>
                                            <span  style={{margin:'0'}}>+</span>
                                        </div>
                                        <div style={{width:'40px',height:'40px',display:'flex',justifyContent:'center',alignItems:"center",border:'1px solid #E5E5E5',borderRadius:'100px'}}>
                                            <span  style={{margin:'0'}}>-</span>
                                        </div> */}
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                          }}
                        >
                          {validations.est}
                        </span>
                      </div>

                      <div style={{ marginBottom: "16px" }}>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            marginBottom: "8px",
                            color: "#212129",
                            display: "block",
                          }}
                        >
                          Add Subcomponent
                        </span>
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                            width: "100%",
                          }}
                        >
                          {/* <input type="text" placeholder="Enter here ..." style={{padding:'16px 8px 16px 8px',gap:'77px',borderRadius:'10px',border:'0.7px solid #E5E5E5',height:'44px',fontFamily:'Satoshi',fontWeight:'400',fontSize:'13px',lineHeight:'17.55px',color:'#8790A1',width:'100%'}}/> */}
                          <SearchWithAPI
                            onDropdownChange={handleSubComponentDropdownChange}
                            apiUrl={apiUrl + `get_subcomponent`}
                            placeholder={"Enter subcomponent here..."}
                            selectedOption={selectedSubComponentOption}
                          />
                          <div
                            onClick={() => {
                              if (selectedSubComponentOption != null) {
                                console.log(selectedSubComponentOption);

                                const index = subComponents.findIndex(
                                  (option) =>
                                    option.value ===
                                    selectedSubComponentOption.value
                                );
                                console.log("index...", index);
                                if (index === -1) {
                                  setSubComponents([
                                    ...subComponents,
                                    selectedSubComponentOption,
                                  ]);
                                  settSubComponentOption(null);
                                }
                              }
                            }}
                            style={{
                              cursor: "pointer",
                              position: "absolute",
                              right: "2%",
                              top: "50%",
                              transform: "translateY(-50%)",
                              padding: "7px 15px 7px 15px",
                              backgroundColor: "#D4DBFF",
                              borderRadius: "8px",
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                            }}
                          >
                            Add
                          </div>
                        </div>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 400,
                            color: "#FF4444",
                          }}
                        >
                          {validations.subcomponents}
                        </span>
                      </div>

                      <div style={{ marginBottom: "16px" }}>
                        <div>
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "12px",
                              lineHeight: "16.2px",
                              color: "#6929E2",
                            }}
                          >
                            Added sub components : {subComponents.length}{" "}
                          </span>
                          <div style={{ height: "150px", overflowY: "auto" }}>
                            {" "}
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "8px",
                              }}
                            >
                              {subComponents.map((item, index) => (
                                <div
                                  key={`${index}-subcomponent`}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    borderRadius: "8px",
                                    padding: "4px 8px 4px 8px",
                                    gap: "8px",
                                    backgroundColor: "#F5F7F9",
                                    marginRight: "8px",
                                  }}
                                >
                                  <div>
                                    <span
                                      style={{
                                        fontFamily: "Satoshi",
                                        fontWeight: "500",
                                        fontSize: "12px",
                                        lineHeight: "20px",
                                        color: "#212129",
                                        margin: "0",
                                      }}
                                    >
                                      {item.label}
                                    </span>
                                  </div>
                                  <img
                                    onClick={() => {
                                      const updatedItems = [...subComponents];
                                      updatedItems.splice(index, 1);
                                      setSubComponents(updatedItems);
                                    }}
                                    src={cancel}
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="col-4"></div>

                        <div
                          onClick={handleClose}
                          style={{
                            borderRadius: "100px",
                            border: "0.6px solid #E5E5E5",
                            padding: "10px 28px 10px 28px",
                            backgroundColor: "#FFFFFF",
                            cursor: "pointer",
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#21272C",
                            }}
                          >
                            Cancel
                          </span>
                        </div>

                        <div
                          onClick={() => {
                            componentSubmit();
                          }}
                          style={{
                            borderRadius: "100px",
                            border: "0.6px solid #E5E5E5",
                            padding: "10px 28px 10px 28px",
                            backgroundColor: "#3253EB",
                            cursor: "pointer",
                          }}
                        >
                          <span
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "700",
                              fontSize: "14px",
                              lineHeight: "18.9px",
                              color: "#FFFFFF",
                            }}
                          >
                            Save
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: "16px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                      fontSize: "14px",
                      lineHeight: "22px",
                      color: "#212129",
                      margin: "0",
                    }}
                  >
                    Total escalations: {totalCount}
                  </p>
                </div>

                <div
                  style={{
                    height: "40px",
                    gap: "6px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: "16px",
                  }}
                >
                  <div>
                    <input
                      type="search"
                      placeholder="Search escalations"
                      onChange={(event) => {
                        setSearchTerm(event.target.value);
                        handleSearch(event.target.value);
                      }}
                      style={{
                        width: "300px",
                        height: "40px",
                        borderRadius: "100px",
                        border: "0.5px solid #E5E5E5",
                        padding: "14px 16px 14px 16px",
                        gap: "6px",
                        backgroundColor: "#FFFFFF",
                      }}
                    />
                  </div>
                   <ReportButton
                    loading={reportLoading}
                    onClick={() => downloadReport({ status, search: searchTerm })}
                  />
                  <div>
                    {/* <select
                      value={status}
                      onChange={(event) => {
                        setStatus(event.target.value);
                      }}
                      style={{
                        width: "127px",
                        height: "40px",
                        borderRadius: "100px",
                        border: "1.4px solid #6929E2",
                        backgroundColor: "#FFFFFF",
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "13px",
                        lineHeight: "17.55px",
                        color: "#6929E2",
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        paddingTop: "11px",
                        paddingBottom: "11px",
                      }}
                    >
                      <option value="All">All</option>
                      <option value="Active">Active</option>
                      <option value="InActive">InActive</option>
                    </select> */}

                  </div>
                </div>
              </div>

              <div
                style={{
                  borderRadius: "8px",
                  paddingTop: "16px",
                  paddingBottom: "16px",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <div
                  style={{
                    height: "42px",
                    flex: "10",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px 12px 16px",
                    backgroundColor: "#F2F2F2",
                  }}
                >
                  <div
                    className="col-2"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Name
                  </div>
                  <div
                    className="col-2"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Region
                  </div>
                  <div
                    className="col-2"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Location
                  </div>
                  <div
                    className="col-3"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Project
                  </div>
                  <div
                    className="col-3"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Component
                  </div>
                </div>
                <div>
                  {escalationList.map((item, index) => (
                    <div
                      key={item.id ?? "table-list" + index}
                      style={{ position: "relative", cursor: "pointer" }}
                    >
                      <div
                        style={{
                          height: "40px",
                          flex: "10",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "6px 16px 6px 16px",
                          backgroundColor: "#FFFFFF",
                          borderBottom: "0.6px solid #D4DDE7",
                        }}
                      >
                        <div
                          className="col-2"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#212129",
                          }}
                        >
                          {item.name}
                        </div>
                        <div
                          className="col-2"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#212129",
                          }}
                        >
                          {item.region ?? ""}
                        </div>
                        <div
                          className="col-2"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#212129",
                            display: "-webkit-box",
                            WebkitLineClamp: 2, // max 5 lines
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden", // hide overflow
                            textOverflow: "ellipsis", // show "..." if text is too long
                          }}
                          title={item.location}
                        >
                          {item.location ?? ""}
                        </div>
                        <div
                          className="col-3"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#212129",
                          }}
                        >
                          {item.project ?? ""}
                        </div>

                        <div
                          style={{
                            flex: "4",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <span
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "400",
                                fontSize: "14px",
                                lineHeight: "22px",
                                color: "#212129",
                                flex: "3",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              {item.component ?? ""}{" "}
                              {/* <span style={{fontFamily:'Satoshi',fontWeight:'500',fontSize:'13px',lineHeight:'17.55px',color:'#8790A1'}}>... +5 more</span> */}
                            </span>

                            {checkPermission(
                              "Escalation",
                              "edit_permission"
                            ) && (
                              <div
                                onClick={() => {
                                  navigate("/escalation/add", {
                                    state: { id: item.id },
                                  });
                                }}
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100px",
                                  gap: "10px",
                                  backgroundColor: "#FFFFFF",
                                  cursor: "pointer",
                                }}
                              >
                                <img
                                  src={edit}
                                  style={{ width: "14px", height: "14px" }}
                                />
                              </div>
                            )}

                            {checkPermission(
                              "Escalation",
                              "delete_permission"
                            ) && (
                              <div
                                onClick={() => {
                                  deleteTeam(item.id);
                                }}
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100px",
                                  gap: "10px",
                                  cursor: "pointer",
                                  backgroundColor: "#FFFFFF",
                                }}
                              >
                                <img
                                  src={dt}
                                  style={{ width: "14px", height: "14px" }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <ListFooter
                  itemsPerPage={itemsPerPage}
                  onItemsPerPageChange={(n) => {
                    setItemOffset(0);
                    setItemsPerPage(n);
                  }}
                  pagination={
                    <ReactPaginate
                      previousLabel={
                        <img src={lar} className="ar3" alt="previous" />
                      }
                      nextLabel={<img src={rar} className="ar3" alt="next" />}
                      breakLabel={"..."}
                      pageCount={pageCount + 1}
                      forcePage={Math.min(
                        Math.floor(itemOffset / itemsPerPage),
                        pageCount
                      )}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                    />
                  }
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <DeleteModal
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        onDelete={deleteApi}
        title="Delete Escalation"
        message="You won’t able to access your escalation after deleting. Are you sure want to delete?"
      />
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          {/*  <Toast.Header>
                                                    <strong className="mr-auto">Snackbar Title</strong>
                                                  </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};

export default EscalationList;
